import React, { Fragment, memo, useMemo, useState } from 'react';
import { Collapse } from 'reactstrap';
import { EstimateService } from '@business/services';
import { TableColumn } from '@modules/common/TableColumn';
import { Formatter } from '@core/utils/formatter';
import { EstimateItemGroupData } from '@modules/organizations/OrganizationPage/Components/Design/EstimateForm';
import './index.scss';
import { R } from '@core/utils/r';

export interface VccEstimateGroupProps {
  group: EstimateItemGroupData;
  primaryColor?: string;
}

export const VccEstimateGroup = memo((props: VccEstimateGroupProps) => {
  const { group, primaryColor } = props;
  const [isOpen, setOpen] = useState(false);

  const groupItems = useMemo(() => group.items.filter(o => !o.weProvide && EstimateService.getMaterialPrice(o) > 0), [group]);

  return (
    <Fragment>
      <div className="proposal-table-header">
        <TableColumn width={50} maxWidth={50}>
          <a className="ml-2" onClick={() => setOpen(!isOpen)}>
            <i className={`bx bx-chevron-${isOpen ? 'up' : 'down'} font-size-22`}></i>
          </a>
        </TableColumn>
        <TableColumn maxWidth={450}>{group.name}</TableColumn>
        <TableColumn></TableColumn>
        <TableColumn maxWidth={100}></TableColumn>
        <TableColumn maxWidth={100}></TableColumn>
        <TableColumn style={{ marginLeft: 20 }} maxWidth={200}>
          {Formatter.formatCurrency(EstimateService.getVccGroupTotal(group), 'USD')}
        </TableColumn>
      </div>
      <Collapse isOpen={isOpen} className="mb-3">
        <VccEstimateGroupHeader primaryColor={primaryColor} />
        {groupItems.map(item => {
          const totalQty = R.toNumber(item.quantity) + (item.manualQty ? R.toNumber(item.manualQty) : 0);
          return (
            <div className="d-flex proposal-price-item" key={item.id}>
              <TableColumn width={80} maxWidth={80}></TableColumn>
              <TableColumn>{item.homeOwnerDescription ?? item.title ?? item.customTitle}</TableColumn>
              <TableColumn maxWidth={100}>{totalQty}</TableColumn>
              <TableColumn maxWidth={100}>{item.materialPrice}</TableColumn>
              {/* <TableColumn maxWidth={100}>{item.laborPrice}</TableColumn> */}
              <TableColumn style={{ marginLeft: 20 }} maxWidth={200}>
                {Formatter.formatCurrency(EstimateService.getMaterialPrice(item), 'USD')}
              </TableColumn>
            </div>
          );
        })}
      </Collapse>
    </Fragment>
  );
});

export const VccEstimateGroupHeader = memo((props: { primaryColor?: string }) => {
  return (
    <Fragment>
      <div className="proposal-table-header without-border" style={{ color: props.primaryColor }}>
        <TableColumn width={80} maxWidth={80}></TableColumn>
        <TableColumn>Description</TableColumn>
        <TableColumn maxWidth={100}>Qty</TableColumn>
        <TableColumn maxWidth={100}>U/Price</TableColumn>
        {/* <TableColumn maxWidth={100}>L/Price</TableColumn> */}
        <TableColumn style={{ marginLeft: 20 }} maxWidth={200}>
          Total
        </TableColumn>
      </div>
    </Fragment>
  );
});
